export enum FeatureFlagName {
  /**
   * Общие для админки и портала флаги
   */
  IsVisibleServiceKindId = 'isVisibleServiceKindId',
  IsVisibleServiceSegments = 'isVisibleServiceSegments',

  /**
   * Флаги Портальной части
   */
  IsVisibleStatisticsInPortal = 'isVisibleStatisticsInPortal', // Видимость раздела статистика на портальной части
  IsVisibleFeedbackBtnInPortal = 'isVisibleFeedbackBtnInPortal',
  IsVisiblePatternInModalPortal = 'isVisiblePatternInModalPortal',
  IsVisibleLinksToEthnoportalInPortal = 'isVisibleLinksToEthnoportalInPortal',
  IsVisibleAISearchInPortal = 'isVisibleAiSearchInPortal',

  /**
   * Флаги Административной части
   */
  IsVisibleUgraIdInAdmin = 'isVisibleUgraIdInAdmin',
  IsVisibleExcerptTtp = 'isVisibleExcerptTtp',
  IsVisibleExcerptOrganization = 'isVisibleExcerptOrganization',
  IsVisibleIntegrationExcerpt = 'isVisibleIntegrationExcerpt',

  // Используется для отображения и редактирования дополнительных полей в реестре физических лиц ЯНАО
  IsVisiblePersonNomadic = 'isVisiblePersonNomadic',

  /**
   * Поддерживается ли отображение периода малоимущности (ответ от зарпоса в ИС Соцзащиты) в карточке ФЛ
   */
  SupportsLowIncomeIntegration = 'supportsLowIncomeIntegration',

  /**
   * Отображение статуса СВО у ФЛ и запуск запроса Минобороны по семье (ЯНАО)
   */
  SupportsSvoCategory = 'supportsSvoCategory',

  /**
   * Наличие настройки "Иницирующая интеграция" при создании/редактировании.
   */
  IsInitialIntegrationAvailable = 'isInitialIntegrationAvailable',
  /**
   * Наличие раздела Регстандарт ТМЦ/ЧК
   */
  HasTMCRegistry = 'hasTMCRegistry',
  /**
   * Наличие справочника Банков
   */
  HasBanks = 'hasBanks',
  /**
   * Наличие раздела договора с банками в Департаментах
   */
  HasBankAgreements = 'hasBankAgreements',
  /**
   *
   */
  HasNSUDRegistry = 'hasNSUDRegistry',
  /**
   * Наличие расширенного учёта оленей
   */
  IndividualDeer = 'individualDeer',

  /**
   * Видимость вкладки в шапке на портале на каналы "Объясняем.КМНС"
   */
  isVisibleChannelsExplainKmns = 'isVisibleChannelsExplainKmns',
  /**
   * Актуализация данных о физических лицах через интеграции
   */
  HasIntegrationActualizations = 'hasIntegrationActualizations',

  /**
   * Отображение списка ФЛ особым образом (по заказу ЯМАЛА) и процесс работы с реестром
   * присущий только ЯНАО.
   * А именно:
   * - отображать для несуперадмина по умолчанию только кочевников и полукочевников;
   * - скрыть некоторые фильтра в модалке расширенных фильтров;
   * - для несуперадмина отображать граждан только с их МО;
   * - необязательность акта при смене представителя домохозяйства.
   */
  PhysicalPersonCustomWay = 'PhysicalPersonCustomWay',

  /**
   * Поддержка интеграции с органами ЗАГС ЕГИССО для получения свидетельств о смерти/рождении
   * в режиме подписки (без отправки запроса по ФЛ)
   */
  SupportsZagsEGISSOIntegration = 'SupportsZagsEGISSOIntegration',

  /**
   * Отображать лейбл находится в реестре отечественного ПО
   */
  IsInRussianSoftwareRegistry = 'isInRussianSoftwareRegistry',

  /**
   * Доступность выгрузки всех ФЛ в XML для Депздрава ЯНАО
   */
  HasDepzdravPersonExport = 'hasDepzdravPersonExport',

  /**
   * Доступны ли документы из прошлой системы
   */
  HasLegacyDocuments = 'hasLegacyDocuments',

  /**
   * Доступны ли Реквизиты счета
   */
  HasBankAccount = 'hasBankAccount',

  /**
   * Используется ли "адресация" заявлений по услуге. Сама услуга принадлежит департенту.
   * Но казывается подразделениями на местах. И определяется значением поля upolnomochennyi_organ
   */
  HasAuthorizedOrgans = 'hasAuthorizedOrgans',

  /**
   * Поддерживаются ли отчетные формы для ЯНАО
   */
  SupportsYanaoReports = 'supportsYanaoReports',

  /**
   * Скачивание и загрузка шаблона формы отчётности.
   * Только ЯНАО: на ХМАО сценарий массовой загрузки не принимали.
   */
  HasReportFormTemplateImport = 'hasReportFormTemplateImport',

  /**
   * Сводка нескольких одобренных отчётов одной формы: показатель один раз, под ним даты.
   * Пока только ЯНАО.
   */
  HasReportFormConsolidation = 'hasReportFormConsolidation',

  /**
   * УКЭП заполненной формы отчётности.
   * Только ЯНАО: на ХМАО кнопки нет, статус на проверку без подписи не блокируется.
   */
  HasReportFormSignature = 'hasReportFormSignature',

  /**
   * Выгрузка формы в PDF и XML.
   * Только ЯНАО: на ХМАО остаётся прежняя кнопка XLSX.
   */
  HasReportFormPdfXml = 'hasReportFormPdfXml',

  /**
   * Необязательное приложение к заполненному отчёту на дату.
   * Только ЯНАО: на ХМАО поле не показываем. Запись на бэкенде не блокируется.
   */
  HasReportFormAttachment = 'hasReportFormAttachment',

  /**
   * Флаг, обозначающий, что сборка поддерживает работу с реестром ТТП
   */
  HasTtpRegistry = 'hasTtpRegistry',
  /**
   * Флаг, обозначающий, что сборка поддерживает работу с реестром ТХД
   */
  HasThdRegistry = 'hasThdRegistry',
  /**
   * Флаг, обозначающий, что сборка поддерживает работу с реестром ТОЖ
   */
  HasTojRegistry = 'hasTojRegistry',

  /**
   * Доступен ли в сборке раздел с комиссиями
   */
  SupportsCommissions = 'supportsCommissions',

  /**
   * Используется ли в сборке directum-like документы
   */
  SupportsDirectumLikeDocuments = 'supportsDirectumLikeDocuments',

  /**
   * Показать раздел "Мои сертификаты"
   */
  HasMyCertificates = 'hasMyCertificates',

  /**
   * Раздел файлов заявления в карточке: просмотр виртуальной папки + zip.
   * Пока только ЯНАО (KMNS-2061 / п. 4.5.2 ЭЦП) — на ХМАО не показываем,
   * чтобы не открывать пустой Explorer там, где сценарий не принимали.
   */
  HasIssueDocuments = 'hasIssueDocuments',

  /**
   * Раздел «Статистика активности» (KMNS-2041 / п. 4.6 АРГИШ).
   * Пока только ЯНАО — на ХМАО уже есть RMS-«Статистика» с другим API.
   */
  HasUserActivityStatistics = 'hasUserActivityStatistics',

  /**
   * Журнал «Действия пользователей». Только ЯНАО: на ХМАО раздел не принят.
   */
  HasUserActions = 'hasUserActions',

  /**
   * RMS-«Статистика» (charts). Только ХМАО: у ЯНАО вместо неё «Статистика активности».
   */
  HasRmsStatistics = 'hasRmsStatistics',
}

export enum RegionFeatureLabel {
  TTP = 'TTP',
  Household = 'Household',
}

export enum RegionEnv {
  HMAO = 'hmao',
  YANAO = 'yanao',
}
